import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=a8b17f16&scoped=true&"
import script from "./CookiesPolicy.vue?vue&type=script&lang=ts&"
export * from "./CookiesPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b17f16",
  null
  
)

export default component.exports